import { useEffect } from 'react';
import { useSetRecoilState } from 'recoil';

import { networkStatusState } from '@store';

import { isAndroid, isTizen, isX1 } from '../helpers/Platform';

export const useNetworkStatus = () => {
  const setNetworkStatus = useSetRecoilState(networkStatusState);

  useEffect(() => {
    if (isAndroid) {
      // TODO: Not sure if we need this yet, might need to import @react-native-community/netinfo if so
    }

    if (isX1) {
      // TODO: Figure out how to read this state
    }

    if (isTizen) {
      const tizenNetworkListener = window.tizen.systeminfo.addPropertyValueChangeListener(
        'NETWORK',
        networkProperty => {
          const networkType = networkProperty.networkType;

          if (networkType === 'NONE') {
            setNetworkStatus({
              connected: false,
              connectionType: networkType,
            });
          } else {
            setNetworkStatus({
              connected: true,
              connectionType: networkType,
            });
          }
        },
      );

      return () => {
        window.tizen.systeminfo.removePropertyValueChangeListener(tizenNetworkListener);
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
